import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import PersonIcon from "@/components/icons/PersonIcon";
import GroupIcon from "@/components/icons/GroupIcon";
import NotificationIcon from "@/components/icons/NotificationIcon";
import QuestionIcon from "@/components/icons/QuestionIcon";
import InvitationIcon from "@/components/icons/InvitationIcon";
import CooperationPlusIcon from "@/components/icons/CooperationPlusIcon";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#57B98F',
        error: '#F83333'
      },
    },
  },
  icons: {
    values: {
      person: {
        component: PersonIcon, // you can use string here if component is registered globally
      },
      group: {
        component: GroupIcon
      },
      notification: {
        component: NotificationIcon
      },
      question: {
        component: QuestionIcon
      },
      invitation: {
        component: InvitationIcon
      },
      cooperationPlus: {
        component: CooperationPlusIcon
      }
    }
  }
});
